import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import _LabelInputBase from '../_LabelInputBase/_LabelInputBase';
import template from './ColorPicker.html?raw';
import { AccessibilityLabelsHelper } from "../../../more/Helpers";
//import DataItems = require("DataItems");



interface fullColor extends more.EntityAPIColor {

}

interface dualColor {
    txtHex: string;
    bgHex: string;
}
class ColorPicker extends compose(_LabelInputBase) {
    templateString: any = template;

    private colorPartsContainer: HTMLInputElement;
    private sectionTXT: HTMLInputElement;
    private sectionBG: HTMLInputElement;
    private inputBgColor: HTMLInputElement;
    private inputTextColor: HTMLInputElement;
    private inputNodeContainer: HTMLElement;
    private _showPreview: boolean = true;
    private previewContainer: HTMLElement;
    private previewNode: HTMLElement;
    //private previewContainerSingle: HTMLElement;
    //private previewNodeSingle: HTMLElement;
    //errorMsgNode: HTMLSpanElement;
    validationMsgNodeContainer = "errorMsgNode";

    private isBgColorValue: boolean = false;
    private isTxtColorValue: boolean = false;

    private isBGdark: boolean = false;

    private btnRemoveTxtColor: HTMLButtonElement;
    private btnRemoveBgColor: HTMLButtonElement;

    private _useBgComponent: boolean = true;
    private _useTxtComponent: boolean = true;
    

    title: string;

    pseudoValueDark: string = "#000000";
    pseudoValueBright: string = "#ffffff";

    protected highlightOnEmptyValue: boolean = false;
    protected _manualHighlightOverride: boolean = false;


    // Methods

    focus() {
        this.inputBgColor.focus();
    }

    protected setInputValue(): void {
        this.inputBgColor.value = this._value ? this._value : "";
    }

    setTitle(title: string): void {
        this.title = title;
        this.UiModder.domAttr.set(this.inputNodeContainer, "title", title);
    }

    getTitle(): string {
        return this.title;
    }

    setLabel(label: string, previewLabel?: string) {
        super.setLabel.apply(this, arguments as any);

        if (previewLabel) {
            this.previewNode.innerHTML = previewLabel;
            this.setUsePreview(true);
        }
    }

   
    protected _onkeyUp_inputNode(evt: KeyboardEvent): void {
        //this.emit("keyUp")
        //console.debug(this.id + " keyUp", evt, this.inputNode);
        if (evt.key == "Enter") {
                this._onBlur(evt); // oder nur so tun als obs ein Blur wär (Cursort bleibt im Feld)
                return;
        }

        if (evt.key == "Escape") {
            this.inputBgColor.blur(); 
        }
    }

    setUseTextColor(bUse: boolean = true) {
        this._useTxtComponent = bUse !== false;

        this.hideNode(this.sectionTXT, bUse === false);

        this._handlePreviewVisibility();
    }
    setUseBackgroundColor(bUse: boolean = true) {
        this._useBgComponent = bUse !== false;

        this.hideNode(this.sectionBG, bUse === false);

        this._handlePreviewVisibility();

    }
    private _handlePreviewVisibility() {
        let bShow = this._showPreview;

        let bIsDualComponent = this._useBgComponent && this._useTxtComponent;
        let bIsSingleComponent = this._useBgComponent != this._useTxtComponent;


        this.hideNode(this.previewContainer, /*bIsDualComponent !== true || */bShow !== true);

        //this.hideNode(this.previewContainerSingle, bIsSingleComponent !== true || bShow !== true);

    }
    setUsePreview(bUse: boolean = true) {
        this._showPreview = bUse;
        this._handlePreviewVisibility();
    }


    setValue(newValue: fullColor | dualColor | string | Array<string>, suppressChangeEvent: boolean = false): void {

        if (this.isReadonly) return;

        let newBgValue: string = null;
        let newTxtValue: string = null;
        if (newValue) {

            if (typeof (newValue) == "string") {

                // enthält String ein : ?
                let arrayValues = newValue.split(":");
                if (arrayValues.length >= 2) {
                    // dann nochmal selber aufrufen
                    this.setValue(arrayValues, suppressChangeEvent);
                    return;
                }

                // Annahme: neue Value ist für BG gedacht
                // testen ob String irgendwie verwertbar?
                let hexValue = this.getHexColorFromString(newValue);

                if (!hexValue) {

                }

                if (hexValue) {
                    newBgValue = hexValue;
                }
            } else if (lang.isArray(newValue) && newValue.length >= 2) {
                // Array
                let val1 = newValue[0]; // BG
                let hexValue = this.getHexColorFromString(val1);
                if (hexValue) newBgValue = hexValue;

                let val2 = newValue[1]; // "TXT"
                hexValue = this.getHexColorFromString(val2);
                if (hexValue) newTxtValue = hexValue;
            }
            else {
                try {
                    let fullColorValue = newValue as fullColor & Object;
                    if (fullColorValue.hasOwnProperty("BackColor")) {
                        if (fullColorValue.BackColor.IsNull === true) {
                            
                        } else {
                            newBgValue = fullColorValue.BackColor.Hex;
                        }
                    }
                    if (fullColorValue.hasOwnProperty("TextColor")) {
                        if (fullColorValue.TextColor.IsNull === true) {

                        } else {
                            newTxtValue = fullColorValue.TextColor.Hex;
                        }
                    }
                } catch (ex) {
                }

                try {
                    let dualColorValue = newValue as dualColor & Object;
                    if (dualColorValue.hasOwnProperty("bgHex")) {
                        newBgValue = dualColorValue.bgHex;
                    }
                    if (dualColorValue.hasOwnProperty("txtHex")) {
                        newTxtValue = dualColorValue.txtHex;
                    }
                } catch (ex) {

                }

            }
        }

        this.inputBgColor.value = newBgValue;
        this.inputTextColor.value = newTxtValue;


        this.isBgColorValue = !!newBgValue;
        this.isTxtColorValue = !!newTxtValue;

        this._afterInputChange(suppressChangeEvent);
    }

    private _afterInputChange(suppressChangeEvent?: boolean) {

        if (this.isReadonly) return;

        let oldValueStr = JSON.stringify(this._value)
        this._serializeData();

        let actuallyChanged = oldValueStr != JSON.stringify(this._value);

        this.validateInput();
        
        if (actuallyChanged) {
            if (!suppressChangeEvent) {
                this.__delayValueChangeEmit(1);
            }
        }
    }

   
    protected customValidation(): boolean {
        let data = this._value;
        let result: boolean = true;

       
        if (this.isMandatory) {
            if (data == undefined || data == "" || data == null) {
                //this.validationErrorMsgText = window.translations['Generic__mandatory'];
                result = false;
            } else if (!this.isBgColorValue && !this.isTxtColorValue) {
                result = false;
            } 
        }

        return result;
    }

    protected _onChange_InputNodeBG(): void {
        if (!this._useBgComponent) return;

        this.isBgColorValue = true;
        this._afterInputChange();
    }
    protected _onChange_InputNodeTXT(): void {
        if (!this._useTxtComponent) return;

        this.isTxtColorValue = true;
        this._afterInputChange();
    }

    /**
     * 
     * @param format
     * @param bReturnNullIfNoColor
     * @returns
     */
    getValue(format?: "dual" | "full" | "TXT" | "BG", bReturnNullIfNoColor?: boolean) {
        let currentValues = this._value;

        if (
            !currentValues ||
            (
                (!this._useBgComponent || !this.isBgColorValue) &&
                (!this._useTxtComponent || !this.isTxtColorValue)
            )
        ) {
            if (bReturnNullIfNoColor == true) {
                return null;
            }
        }

        switch (format) {
            case "dual":
                return this.getDualColor(bReturnNullIfNoColor);
                break;

            case "TXT":
                return this.getTxtColorHex(bReturnNullIfNoColor !== true);
                break;

            case "BG":
                return this.getBgColorHex();
                break;
        }

        // full:
       
        return this._value;
    }

    getColor(bReturnNullIfNoColor?: boolean): fullColor {
        return this.getValue("full", bReturnNullIfNoColor);
    }
    /**
    * Gibt die Textfarbe zurück. usePseudoValue gibt im Falle einer leeren Textkomponente dunkel oder hell, abhängig von der Hintergrundfarbe, zurück.
    * bReturnNullIfNoColor stellt den Rückgabewert auf NULL, wenn alle Komponenten leer oder nicht benutzt sind.
    * Die Pseudofarben können im Colorpicker als Properties pseudoValueBright und pseudoValueDark gesetzt werden.
    */
    getDualColor(usePseudoTxtValue: boolean = true, bReturnNullIfNoColor?: boolean): dualColor {
        let currentValues: fullColor = this._value;

        let returnValue: dualColor = null;

        if (!currentValues || ((!this._useBgComponent || !this.isBgColorValue) && (!this._useTxtComponent || !this.isTxtColorValue))){
            if (bReturnNullIfNoColor == true) {
                return null;
            }
        }

        if (currentValues) {
            returnValue = {
                bgHex: null,
                txtHex: null
            };

            if (this.isBgColorValue === true && this._useBgComponent) {
                returnValue.bgHex = currentValues.BackColor.Hex;
            }

            if (this.isTxtColorValue === true && this._useTxtComponent) {
                returnValue.txtHex = currentValues.TextColor.Hex;
            } else if (usePseudoTxtValue == true) {
                let isDark = true;
                if (returnValue.bgHex) {
                    isDark = this.isBGdark;
                } else {

                }

                returnValue.txtHex = isDark ? this.pseudoValueBright : this.pseudoValueDark;
            }

        }

        return returnValue;

    }

    getBgColorHex(): string {
        let currentValues: fullColor = this._value;
        let returnvalue: string = null;
        if (currentValues && this._useBgComponent == true) {
            if (this.isBgColorValue) {
                returnvalue = currentValues.BackColor.Hex;
            }
        }

        return returnvalue;
    }

    /**
     * Gibt die Textfarbe zurück. usePseudoValue gibt im Falle einer leeren Textkomponente dunkel oder hell, abhängig von der Hintergrundfarbe, zurück.
     * Die Pseudofarben können im Colorpicker als Properties pseudoValueBright und pseudoValueDark gesetzt werden.
     */
    getTxtColorHex(usePseudoValue: boolean = true): string {
        let currentValues: fullColor = this._value;

        let returnvalue: string = null;
        if (currentValues && this._useTxtComponent == true) {
            if (this.isTxtColorValue) {
                returnvalue = currentValues.TextColor.Hex;
            } else if (usePseudoValue) {
                returnvalue = this.isBGdark ? this.pseudoValueBright : this.pseudoValueDark;
            }
        }

        return returnvalue;
    }

    private _handleStyles() {

        let currentValues: fullColor = this._value;

        this.UiModder.domClass.toggle(this.sectionBG, "empty repeatingStripesBG", this.isBgColorValue != true);
        this.disableNode(this.btnRemoveBgColor, this.isBgColorValue != true);

        this.UiModder.domClass.toggle(this.sectionTXT, "empty repeatingStripesBG", this.isTxtColorValue != true);        
        this.disableNode(this.btnRemoveTxtColor, this.isTxtColorValue != true);

        if (this.isBgColorValue && this._useBgComponent) {
            this.previewNode.style.setProperty("--colorBG", this.inputBgColor.value);
            //this.previewNodeSingle.style.setProperty("--color", this.inputBgColor.value);
            //this.UiModder.domStyle.set(this.previewNode, "backgroundColor", this.inputBgColor.value);

            let isDark = this.isBGdark;
            this.UiModder.domClass.toggle(this.previewNode, "darkBG", isDark);

        } else {
            this.previewNode.style.removeProperty("--colorBG");
            this.UiModder.domClass.remove(this.previewNode, "darkBG");

            //this.UiModder.domStyle.set(this.previewNode, "backgroundColor", "");
        }

        if (this.isTxtColorValue && this._useTxtComponent) {
            this.previewNode.style.setProperty("--colorTXT", this.inputTextColor.value);
            //this.previewNodeSingle.style.setProperty("--colorTXT", this.inputTextColor.value);
            //this.UiModder.domStyle.set(this.previewNode, "color", this.inputTextColor.value);
        } else {
            this.previewNode.style.removeProperty("--colorTXT");
            //this.previewNodeSingle.style.removeProperty("--colorTXT");
            //this.UiModder.domStyle.set(this.previewNode, "color", "");
        }
    }

    private _serializeData(): fullColor {
        let value: fullColor = {
            BackColor: {
                IsNull: !this.isBgColorValue,
                Blue: null,
                Green: null,
                Red: null,
                Hex: null
            },
            pitBGR: "ffffffff:ffffffff",
            TextColor: {
                IsNull: !this.isTxtColorValue,
                Blue: null,
                Green: null,
                Red: null,
                Hex: null
            },
        };

        let bgrBG = "ffffffff";
        let bgrTXT = "ffffffff";

        let valueTxt = this.inputTextColor.value;
        let valueBg = this.inputBgColor.value;

        if (!this.isBgColorValue) {
            this.isBGdark = false;
        }
        else {
            let rgb = this.getRgbFromString(valueBg);
            value.BackColor.Hex = valueBg;
            value.BackColor.Red = rgb[0];
            value.BackColor.Green = rgb[1];
            value.BackColor.Blue = rgb[2];

            
            bgrBG = ("00" + rgb[2].toString(16)).slice(-2) + ("00" + rgb[1].toString(16)).slice(-2) + ("00" + rgb[0].toString(16)).slice(-2);

            this.isBGdark = this.isDarkRGBColor(value.BackColor.Red, value.BackColor.Green, value.BackColor.Blue)
        }

        if (!this.isTxtColorValue) {

        } else {
            let rgb = this.getRgbFromString(valueTxt);
            value.TextColor.Hex = valueTxt;
            value.TextColor.Red = rgb[0];
            value.TextColor.Green = rgb[1];
            value.TextColor.Blue = rgb[2];

            bgrTXT = ("00" + rgb[2].toString(16)).slice(-2) + ("00" + rgb[1].toString(16)).slice(-2) + ("00" + rgb[0].toString(16)).slice(-2);

        }

        value.pitBGR = bgrTXT + ":" + bgrBG;

        this._value = value;

        this._handleStyles();

        

        return value;
    }

    private _onClick_RemoveTxtColor(evt: MouseEvent) {
        this.setTxtColor(null);
    }
    
    private _onClick_RemoveBgColor(evt: MouseEvent) {
        this.setBgColor(null);
    }

    protected _setUseBGAttr(bUse: boolean) {
        this.setUseBackgroundColor(bUse);
    }
    protected _setUseTXTAttr(bUse: boolean) {
        this.setUseTextColor(bUse);
    }

    protected _setTitleAttr(title: string) {
        this.setTitle(title);
    }

    protected _getTitleAttr(): string {
        return this.getTitle();
    }

    private setTxtColor(hexColor: string, suppressChangeEvent?: boolean) {
        if (!hexColor) {
            this.inputTextColor.value = null;
            this.isTxtColorValue = false;
        }

        else {
            this.inputTextColor.value = hexColor;
            this.isTxtColorValue = true;
        }

        this._afterInputChange(suppressChangeEvent);
    }
    private setBgColor(hexColor: string, suppressChangeEvent?: boolean) {
      if (!hexColor) {
          this.inputBgColor.value = null;
          this.isBgColorValue = false;
        }

        else {
          this.inputBgColor.value = hexColor;
          this.isBgColorValue = true;
        }

        this._afterInputChange(suppressChangeEvent);
    }
  
    protected _setReadonlyStyle(): void {
        this.disableNode(this.domNode, false); // wir wollen nicht ALLES abblenden

        this.disableNode(this.labelNode, this.isReadonly);
        this.disableNode(this.colorPartsContainer, this.isReadonly);
        
        if (this.labelNode) {
            //this.UiModder.domClass.toggle(this.labelNode, "w3-disabled", this.isReadonly);
        }

        this._setNonInteractiveStyle();
    }

    protected _setNonInteractiveStyle(): void {
        this.hideNode(this.colorPartsContainer, this.isNonInteractive);
        this.hideNode(this.btnRemoveBgColor, this.isNonInteractive || this.isReadonly);
        this.hideNode(this.btnRemoveTxtColor, this.isNonInteractive || this.isReadonly);

        this.UiModder.domClass.toggle(this.inputBgColor, "noInteraction", this.isNonInteractive || this.isReadonly);
        this.UiModder.domClass.toggle(this.inputTextColor, "noInteraction", this.isNonInteractive || this.isReadonly);
    }


    public setAllDataCyAttributes() {
        super.setAllDataCyAttributes.apply(this, arguments as any);
        this.setDataCyAttribute(this.inputBgColor, "inputBgColor");
        this.setDataCyAttribute(this.inputTextColor, "inputTextColor");
        this.setDataCyAttribute(this.btnRemoveBgColor, "btnRemoveBgColor");
        this.setDataCyAttribute(this.btnRemoveTxtColor, "btnRemoveTxtColor");
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        AccessibilityLabelsHelper.InputLabelledbyBind([
            {
                labelElement: this.labelNode, labelIdValue: "colorPickerLabel"
            }],
            this.inputNodeContainer,
            this.id);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);

        this._handleStyles();
    }
}

export default mdsWidget(ColorPicker);